import React from "react"

import {
	GridColDef,
} from "@mui/x-data-grid"

import {
	AssetMatchBrand,
	AssetMatchBrandWithImage,
	OrderType,
	PaginatedResponse,
	SearchFilter,
} from "models"

import getTableColumns, { CompatibleAssetsColumnInterface } from "./table-columns"
import { AssetService } from "../../../services/asset.service";
import withUseRouter, { UseRouterParams } from "../../../services/router";
import { MatesComponent, MatesComponentState } from "../../mates-component";
import { Box, Pagination, Typography } from "@mui/material"
import MatchProposalItemBrand from "components/match-proposal/match-proposal-list-brand/match-proposal-item-brand"
import { MatchService } from "services/match.service"
import { ErrorResponse, RestResponse } from "@sinossi/mates-react-library"

interface CompatibleAssetsTableProps extends UseRouterParams {
	data: PaginatedResponse<AssetMatchBrand> | null
	pagination: SearchFilter
	likes: string[]
	getLikes: () => string[]
	onPaginationChanged: (pageId: number, pageSize: number) => void
	onSortChanged: (orderBy: string | null, orderType: OrderType | null) => void
}

interface CompatibleAssetsTableState extends MatesComponentState {
	mapMatches: AssetMatchBrandWithImage[]
	totalPages: number
	page: number
}

class CompatibleAssetsTable extends React.Component<CompatibleAssetsTableProps, CompatibleAssetsTableState>
	implements CompatibleAssetsColumnInterface {

	private readonly columns: GridColDef[]
	private readonly matesComponent: MatesComponent<CompatibleAssetsTableProps, CompatibleAssetsTableState> = new MatesComponent(this)

	constructor(props: CompatibleAssetsTableProps) {
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			mapMatches: [],
			totalPages: 0,
			page: 1,
		}
		this.columns = getTableColumns(this)
	}

	componentDidMount(): void {
		this.getMatchListByArea()
	}

	private getMatchListByArea = (): void => {
		MatchService.getMatchesByCompanyIdAndArea(
			{
				...this.props.pagination,
				northEastLatitude: 0,
				northEastLongitude: 0,
				southWestLatitude: 0,
				southWestLongitude: 0,
				priorityId: null,
			},
			null,
			this.getMatchByAreaCallback,
			this.matesComponent.onError
		)
	}

	private getMatchByAreaCallback = (response: RestResponse<PaginatedResponse<AssetMatchBrandWithImage>, ErrorResponse>): void => {
		if (response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		this.setState(() => ({
			mapMatches: response.data?.items ?? [],
			totalPages: response.data!.pagination.totalPages,
		}))
	}

	public getLikes(): string[] {
		return this.props.likes
	}

	public toggleLike(id: string, isLike: boolean): void {
		const action = isLike
			? AssetService.removeFromFavourite
			: AssetService.addToFavourite

		action(id, this.addOrRemoveLikeCallback, this.matesComponent.onException)
	}

	private addOrRemoveLikeCallback = (response: any) => {
		if (response.hasError()) {
			this.matesComponent.onError(response)
			return
		}
		this.props.getLikes()
	}

	private handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		this.setState({ page: value }, () => {
			this.props.onPaginationChanged(value - 1, this.props.pagination.pageSize)
		})
	}

	render() {
		const { mapMatches, totalPages, page } = this.state

		return (
			<>
				<Pagination
					showFirstButton
					showLastButton
					page={page}
					count={totalPages}
					onChange={this.handlePageChange}
					siblingCount={2}
					sx={{
						mb: 4,
						display: "flex",
						width: "100%",
						justifyContent: "right",
					}}
				/>

				{mapMatches.length === 0 ? (
					<Typography textAlign="center" sx={{ mt: 4 }}>
						Nessun risultato disponibile.
					</Typography>
				) : (
					mapMatches.map((match) => (
						<Box mb={2}>
							<MatchProposalItemBrand match={match} />
						</Box>
					))
				)}
			</>
		)
	}
}

export default withUseRouter(CompatibleAssetsTable)
